import React from 'react';

// Clean, food-delivery-app-style SVG artwork — replaces the cheap-looking emoji.
// Purely presentational (aria-hidden); colour/size are props so they adapt per surface.

// Serving cloche (room-service dome) — used for the Room Dining action.
export function RoomDiningMark({ size = 28, color = '#E8001D' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      {/* steam */}
      <path d="M20.5 7.5c-1.3 1.2-1.3 2.7 0 3.9M27.5 7.5c-1.3 1.2-1.3 2.7 0 3.9"
        stroke={color} strokeOpacity="0.5" strokeWidth="2" strokeLinecap="round" />
      {/* dome */}
      <path d="M8.5 31a15.5 15.5 0 0 1 31 0Z" fill={color} fillOpacity="0.16" />
      <path d="M8.5 31a15.5 15.5 0 0 1 31 0" stroke={color} strokeWidth="2.4" strokeLinejoin="round" />
      {/* knob */}
      <circle cx="24" cy="14.3" r="2.2" fill={color} />
      {/* plate */}
      <rect x="5.5" y="31" width="37" height="4.6" rx="2.3" fill={color} />
    </svg>
  );
}

// Plated dish with fork + knife — placeholder for a menu item that has no photo yet.
// Tuned to read on a dark card; tone can be overridden.
export function DishPlaceholder({ size = 78, tone = 'rgba(255,255,255,0.18)', fill = 'rgba(255,255,255,0.05)' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      {/* fork */}
      <path d="M14 14v7M17 14v7M20 14v7" stroke={tone} strokeWidth="2" strokeLinecap="round" />
      <path d="M17 21v29" stroke={tone} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      {/* knife */}
      <path d="M47 14c-2.6 1-4 4.6-4 8.4 .3 2.4 1.7 3.6 4 3.8" stroke={tone} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M47 26.2V50" stroke={tone} strokeWidth="2" strokeLinecap="round" />
      {/* plate */}
      <circle cx="32.5" cy="34" r="14.5" fill={fill} stroke={tone} strokeWidth="2" />
      <circle cx="32.5" cy="34" r="8" stroke={tone} strokeWidth="1.4" strokeOpacity="0.7" />
    </svg>
  );
}

const FoodArt = { RoomDiningMark, DishPlaceholder };
export default FoodArt;
